import { Link } from 'react-router-dom';

interface ArticleCardProps {
  article: {
    id: number;
    title: string;
    slug: string;
    excerpt: string;
    coverImage: string;
    author: string;
    authorAvatar: string;
    date: string;
    readTime: string;
    tags: string[];
    category: string;
  };
  categorySlug: string;
  categoryName: string;
}

export default function ArticleCard({ article, categorySlug, categoryName }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <Link
          to={`/category/${categorySlug}`}
          className="inline-block text-xs font-medium text-primary-500 bg-primary-100/70 px-2 py-1 rounded-md mb-3 hover:bg-primary-200/70 transition-colors whitespace-nowrap"
        >
          {categoryName}
        </Link>
        <Link to={`/article/${article.slug}`} className="block">
          <h3 className="font-heading text-base text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-4 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <img
              src={article.authorAvatar}
              alt={article.author}
              className="w-6 h-6 rounded-full object-cover"
            />
            <span className="text-xs text-foreground-500">{article.author}</span>
          </div>
          <div className="flex items-center gap-3 text-xs text-foreground-400">
            <span>{article.date}</span>
            <span>{article.readTime}</span>
          </div>
        </div>
      </div>
    </article>
  );
}